<template>
  <div>
    <b-container fluid class="content">
      <b-row class="mt-4">
        <b-col>
          <b-card>
            <h3 class="mb-3">SMS</h3>
            <el-tabs v-model="activeTab" @tab-click="tabClick">
              <el-tab-pane :label="'SMS'+$t('Record')" name="records">
                <b-form @submit.prevent="searchRecords">
                  <b-row>
                    <b-col md="3">
                      <base-input :label="$t('Start Time')">
                        <b-input v-model="recordFilter.start_dt" type="datetime-local" />
                      </base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input :label="$t('End Time')">
                        <b-input v-model="recordFilter.end_dt" type="datetime-local" />
                      </base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input :label="$t('Stamp')">
                        <b-input v-model="recordFilter.Stamp" />
                      </base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input :label="$t('To Number')">
                        <b-input v-model="recordFilter.ToNumber" />
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-button variant="primary" type="submit" :disabled="loading">{{ $t('Search') }}</b-button>
                </b-form>

                <el-table
                  stripe
                  class="table-responsive table mt-3"
                  header-row-class-name="thead-light"
                  :data="records"
                >
                  <el-table-column :label="$t('Stamp')" prop="Stamp" width="130" />
                  <el-table-column :label="$t('Cost')" width="120">
                    <template slot-scope="scope">{{ money(scope.row.Cost) }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('To Number')" prop="ToNumber" width="160" />
                  <el-table-column :label="'SMS'+$t('Content')" prop="SMSContent" />
                  <el-table-column :label="$t('Time')" prop="CreateTime" width="180" />
                </el-table>
              </el-tab-pane>

              <el-tab-pane :label="$t('Store Transaction')" name="transactions">
                <b-form @submit.prevent="searchTransactions">
                  <b-row>
                    <b-col md="4">
                      <base-input :label="$t('Start Time')">
                        <b-input v-model="transactionFilter.start_dt" type="datetime-local" />
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input :label="$t('End Time')">
                        <b-input v-model="transactionFilter.end_dt" type="datetime-local" />
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input :label="$t('Stamp')">
                        <b-input v-model="transactionFilter.Stamp" />
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-button variant="primary" type="submit" :disabled="loading">{{ $t('Search') }}</b-button>
                </b-form>

                <b-row class="align-items-end mt-3">
                  <b-col md="3">
                    <base-input :label="$t('Payment Amount')">
                      <b-input v-model="paymentAmount" type="number" step="0.0001" min="0" />
                    </base-input>
                  </b-col>
                  <b-col md="5">
                    <base-input :label="$t('Notes')">
                      <b-input v-model="paymentNotes" />
                    </base-input>
                  </b-col>
                  <b-col md="2">
                    <b-button variant="success" class="mb-3" :disabled="loading" @click="addPayment">{{ $t('Add Payment') }}</b-button>
                  </b-col>
                  <b-col md="2" class="text-right mb-3">
                    <strong>{{ $t('Balance') }}: {{ money(balance) }}</strong>
                  </b-col>
                </b-row>

                <el-table
                  stripe
                  class="table-responsive table mt-3"
                  header-row-class-name="thead-light"
                  :data="transactions"
                >
                  <el-table-column :label="$t('Stamp')" prop="Stamp" width="120" />
                  <el-table-column :label="$t('User')" prop="UserName" width="150" />
                  <el-table-column :label="$t('Amount')" width="120">
                    <template slot-scope="scope">{{ money(scope.row.Amount) }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('Balance')" width="130">
                    <template slot-scope="scope">{{ money(scope.row.TotalAmount) }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('Notes')" prop="Notes" />
                  <el-table-column :label="$t('Create Time')" prop="CreateTime" width="180" />
                </el-table>
              </el-tab-pane>

              <el-tab-pane :label="'SMS' + $t('Cost')" name="costs">
                <el-table
                  stripe
                  class="table-responsive table"
                  header-row-class-name="thead-light"
                  :data="editableCosts"
                >
                  <el-table-column :label="$t('Stamp')" prop="Stamp" width="180" />
                  <el-table-column :label="$t('Cost')" width="220">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.Cost"
                        type="number"
                        step="0.0001"
                        min="0"
                        size="mini"
                        :disabled="!canEditCost"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('Update Time')" prop="UpdateTime" />
                  <el-table-column :label="$t('Action')" width="140">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        :disabled="!canEditCost || loading"
                        @click="updateCost(scope.row)"
                      >{{ $t('Update') }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <p v-if="!canEditCost" class="text-muted mt-3">Only PKAdmin or poksing can update SMS cost.</p>
              </el-tab-pane>
            </el-tabs>
            <div v-if="message" class="mt-3">{{ message }}</div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Input, Tabs, TabPane } from "element-ui";
import { getStore } from "../../util/helper";

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Input.name]: Input,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  data() {
    return {
      activeTab: "records",
      loading: false,
      message: "",
      token: "",
      user_id: 0,
      canEditCost: false,
      balance: 0,
      records: [],
      transactions: [],
      costs: [],
      recordFilter: {
        start_dt: "",
        end_dt: "",
        Stamp: "",
        ToNumber: "",
      },
      transactionFilter: {
        start_dt: "",
        end_dt: "",
        Stamp: "",
      },
      paymentAmount: "",
      paymentNotes: "",
    };
  },
  computed: {
    editableCosts() {
      if (this.costs.length) {
        return this.costs;
      }
      return [{ IDn: 0, Stamp: "Order", Cost: "0.0230", UpdateTime: "" }];
    },
  },
  methods: {
    baseFormData() {
      let bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      return bodyFormData;
    },
    appendFilter(bodyFormData, filter) {
      Object.keys(filter).forEach((key) => {
        bodyFormData.append(key, filter[key] || "");
      });
    },
    money(value) {
      let number = Number(value);
      if (!Number.isFinite(number)) {
        number = 0;
      }
      return number.toFixed(4);
    },
    handleResponse(response, onSuccess) {
      if (response.status == "200") {
        let rt = response.data;
        if (rt.status == 0) {
          onSuccess(rt.data || {});
          return;
        }
        if (rt.status == 4) {
          alert(this.$t("No Permission"));
          return;
        }
        if (rt.message != undefined) {
          alert(rt.message);
        }
      }
    },
    request(url, filter, onSuccess) {
      let bodyFormData = this.baseFormData();
      if (filter) {
        this.appendFilter(bodyFormData, filter);
      }
      this.loading = true;
      axios({ method: "post", url, data: bodyFormData })
        .then((response) => this.handleResponse(response, onSuccess))
        .catch(() => this.$router.push("/login"))
        .finally(() => {
          this.loading = false;
        });
    },
    loadAll() {
      this.request("/Api/Web/SMS", null, (data) => {
        this.records = data.records || [];
        this.transactions = data.transactions || [];
        this.costs = data.costs || [];
        this.canEditCost = Boolean(data.can_edit_cost);
        this.balance = data.balance || 0;
      });
    },
    searchRecords() {
      this.request("/Api/Web/SMS/records", this.recordFilter, (data) => {
        this.records = data.records || [];
      });
    },
    searchTransactions() {
      this.request("/Api/Web/SMS/transactions", this.transactionFilter, (data) => {
        this.transactions = data.transactions || [];
        this.balance = data.balance || 0;
      });
    },
    addPayment() {
      let amount = Number(this.paymentAmount);
      if (!Number.isFinite(amount) || amount <= 0) {
        alert("Payment amount must be greater than 0");
        return;
      }
      let bodyFormData = this.baseFormData();
      this.appendFilter(bodyFormData, this.transactionFilter);
      bodyFormData.append("Amount", amount);
      bodyFormData.append("Notes", this.paymentNotes || "");
      this.loading = true;
      axios({ method: "post", url: "/Api/Web/SMS/add_payment", data: bodyFormData })
        .then((response) => this.handleResponse(response, (data) => {
          this.transactions = data.transactions || [];
          this.balance = data.balance || 0;
          this.paymentAmount = "";
          this.paymentNotes = "";
          this.message = "Payment added";
        }))
        .catch(() => this.$router.push("/login"))
        .finally(() => {
          this.loading = false;
        });
    },
    updateCost(row) {
      let cost = Number(row.Cost);
      if (!Number.isFinite(cost) || cost < 0) {
        alert("Cost can not be negative");
        return;
      }
      let bodyFormData = this.baseFormData();
      bodyFormData.append("Stamp", row.Stamp || "Order");
      bodyFormData.append("Cost", cost);
      this.loading = true;
      axios({ method: "post", url: "/Api/Web/SMS/update_cost", data: bodyFormData })
        .then((response) => this.handleResponse(response, (data) => {
          this.costs = data.costs || [];
          this.message = "SMS cost updated";
        }))
        .catch(() => this.$router.push("/login"))
        .finally(() => {
          this.loading = false;
        });
    },
    tabClick() {
      this.message = "";
    },
  },
  mounted() {
    this.token = getStore("token");
    this.user_id = getStore("user_id");
    this.loadAll();
  },
};
</script>
